import { LinkIcon } from '@chain-zen/ui'
import { AppTypeEnum } from '@chaine/types'

import type { VisibilityProviderEnum } from '../../../../types/tracking'
import { FourKitesIcon } from './four-kites-icon'

interface IVisibilityProviderIcon {
  provider: VisibilityProviderEnum | string | null | undefined
  size?: number
}

/**
 * Icon component for visibility providers - shows specific icons for known providers
 * and falls back to UnknownLinkIcon for unknown providers
 */
export const VisibilityProviderIcon = (props: IVisibilityProviderIcon) => {
  const { provider, size } = props
  const iconSize = (size || 3) * 4

  return provider === AppTypeEnum.FourKitesCarrier ? <FourKitesIcon size={size} /> : <LinkIcon size={iconSize} />
}

VisibilityProviderIcon.displayName = 'VisibilityProviderIcon'
